import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { createColumnHelper } from "@tanstack/react-table";

import { useFilters } from "../../../hooks/useFilters";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/Table";
import { BusinessUser } from "../../../services/queries/users/types";
import Button from "../../../components/Button";
import {
  useGetUsers,
  usersResourcePath,
} from "../../../services/queries/users";
import { formatDate } from "../../../utils";
import Drawer from "../../../components/Drawer";
import AddUserForm from "../../../components/forms/AddUserForm";
import { requireRouteAccess } from "../../../utils/authorization";

const columnHelper = createColumnHelper<
  BusinessUser & { actions: "actions" }
>();

const columns = [
  columnHelper.accessor("user.firstName", {
    cell: (info) => info.getValue(),
    header: "First Name",
  }),
  columnHelper.accessor("user.lastName", {
    cell: (info) => info.getValue(),
    header: "Last Name",
  }),
  columnHelper.accessor("user.email", {
    cell: (info) => info.getValue(),
    header: "Email",
  }),
  columnHelper.accessor("user.phone", {
    cell: (info) => info.getValue(),
    header: "Phone",
  }),
  columnHelper.accessor("role", {
    cell: (info) => info.getValue(),
    header: "Role",
  }),
  columnHelper.accessor("createdAt", {
    cell: (info) => formatDate(info.getValue()),
    header: "Created",
  }),
  columnHelper.accessor("actions", {
    cell: () => {
      // const { id } = row.original;

      return (
        <div className="flex gap-4">
          {/* <Button>
            Create Wallet
          </Button> */}
        </div>
      );
    },
    header: "",
  }),
];

export const Route = createFileRoute("/_app/users/")({
  beforeLoad: () => requireRouteAccess("/users"),
  component: Users,
});

function Users() {
  const {
    filters: { pageNumber, pageSize },
    setFilters,
    buildApiUrl,
  } = useFilters();

  const url = buildApiUrl(usersResourcePath);

  const handlePageChange = (selectedItem: { selected: number }) => {
    setFilters({ pageNumber: selectedItem.selected + 1 });
  };

  const { isLoading, data: usersData } = useGetUsers(url);

  const users = usersData?.data?.list || [];
  const totalRecords = usersData?.data?.meta?.total || 0;
  const pageCount = Math.ceil(totalRecords / Number(pageSize));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div className="flex flex-col space-y-6">
      <div className="flex items-center justify-end">
        <Button variant="primary" onClick={() => setIsDrawerOpen(true)}>
          Add User
        </Button>
      </div>

      <div className="bg-white overflow-x-auto relative p-6">
        <Table
          loading={isLoading}
          data={users}
          columns={columns}
          rowClassName="uppercase"
        />

        <Pagination
          pageCount={pageCount}
          currentPage={pageNumber}
          onPageChange={handlePageChange}
        />
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Invite Team Member"
      >
        <AddUserForm onClose={() => setIsDrawerOpen(false)} />
      </Drawer>
    </div>
  );
}
